import {AzureAdConfigs} from './azure-ad-configs';
import {FormGroup} from '@angular/forms';

export const Util = {
  azureAdCoinfigs: {
    tenentId: '7370ba97-d711-4694-a8dd-1f7e9ea960ed',
    clientId: 'c1c073bc-143f-42ef-9d2c-5b5241be5ec2',
    clientSecret: 'qrF8Q~JTZssnnq9NsSc2d.qCKITIwqJ8Hy1Dia_n',
    callBackPath: 'http://localhost',
    enabled: false,
  } as AzureAdConfigs
};

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({mustMatch: true});
    } else {
      matchingControl.setErrors(null);
    }
  };
}
